module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('p', [_vm._v("Referente a sede da empresa")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("IPTU ou Habite-se do Imóvel onde será a sede da empresa;")]), _vm._v(" "), _c('li', [_vm._v("Cópia do Contrao de Locação se for o caso")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Documentos do(s) empresário, sócio(s), presidente, titular:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cópia da Identidade (RG);")]), _vm._v(" "), _c('li', [_vm._v("CPF;")]), _vm._v(" "), _c('li', [_vm._v("Comprovante de Residência")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "arquivos"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://cdn.icnex.com/formularios5/?arquivos&adicionar",
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "before-upload": _vm.beforeUpload,
      "on-remove": _vm.onRemove,
      "file-list": _vm.form.arquivos
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.disableField
    }
  }, [_vm._v("Clique aqui para fazer o upload")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Validação para poder enviar a solicitação")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-799466fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConstituicaoDeEmpresa/DocumentosNecessarios.vue
// module id = 206
// module chunks = 1